import React from "react";
import UserTypeManagementTable from "./UserTypeManagementTable";


const UserTypeManagement = () => {

  return <div>{<UserTypeManagementTable />}</div>;
};

export default UserTypeManagement;
